// extracted by mini-css-extract-plugin
module.exports = {"container":"IsDone_container__2zB1Y","title":"IsDone_title__dhaRv","icon":"IsDone_icon__3iwyR","description":"IsDone_description__JAcK-"};